import React, { Component } from "react";
import BaseComponent from "../BaseComponent.js";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";

import NanoFlex from "../Global/NanoFlex.js";
import Type from "../Global/Typography.js";
import Dropdown from "../Nano/Dropdown.js";
import Spinner from "../Nano/Spinner.js";

//IMAGES
import { ReactComponent as Playlist } from "../Global/Icons/playlist.svg";
import { ReactComponent as RemovePlaylist } from "../Global/Icons/removePlaylist.svg";
import { ReactComponent as Pdf } from "../Global/Icons/pdf.svg";
import { ReactComponent as Excel } from "../Global/Icons/excel.svg";
import { ReactComponent as Thumbs } from "../Global/Icons/thumbs.svg";
import { ReactComponent as List } from "../Global/Icons/list.svg";
import { ReactComponent as Check } from "../Global/Icons/check.svg";
import { ReactComponent as AdvancedSearchIcon } from "../Global/Icons/advancedSearch.svg";
import { ReactComponent as Delete } from "../Global/Icons/close.svg";
import { ReactComponent as Minus } from "../Global/Icons/minus.svg";
import { ReactComponent as Expand } from "../Global/Icons/expand.svg";
import { ReactComponent as Eye } from "../Global/Icons/eye.svg";
import { ReactComponent as EyeClosed } from "../Global/Icons/eyeClosed.svg";
import { ReactComponent as Plus } from "../Global/Icons/plus.svg";
import { ReactComponent as DotsMenu } from "../Global/Icons/dotsMenu.svg";

const multiple = nota.global.multiple;

const StyledLoading = styled(NanoFlex)`
  height: 52px;
  margin-top: 8px;
  background-color: ${nota.color.neutral.NeuFour};
`;

class FilterRecapItem extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      viewMore: false,
    };

    this.maxItems = 3;
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  toggleViewMore = () => {
    this.setState({ viewMore: !this.state.viewMore });
  };

  deleteFilter = () => {
    window.dispatchEvent(new CustomEvent("deleteFilter", { detail: [this.props.item] }));
  };

  render() {
    let values = [...this.props.item.values];

    if (this.props.item.isAllSelected) {
      values = [{ name: this.translation.geral.allSelected }];
    }

    let plus = null;
    if (values.length > this.maxItems) {
      plus = values.length - this.maxItems;
      if (!this.state.viewMore) {
        values = values.splice(0, this.maxItems);
      }
    }

    return (
      <NanoFlex key={this.props.item.field} className="sliderItem" flexDirection="column" alignItems="flex-start">
        <NanoFlex className="titleWrapper" justifyContent="flex-start">
          <Type.p>{this.props.item.translation}</Type.p>
          <NanoFlex className="deleteInfo" onClick={this.deleteFilter}>
            <Delete />
          </NanoFlex>
        </NanoFlex>

        <NanoFlex className="highlightsList" justifyContent="flex-start">
          {/* HIGHLIGHT CONTAINER */}
          {values.map((val) => {
            return (
              <NanoFlex key={val.id ?? val.name} className="highlightContainer">
                <NanoFlex className="highlightWrapper">
                  <Type.p className="highlightInfo" title={val.name}>
                    <b>{val.name}</b>
                  </Type.p>
                  {val?.childs?.length && <Type.p className="highlightInfo nivel2">({val?.childs?.length})</Type.p>}
                </NanoFlex>
              </NanoFlex>
            );
          })}
          {!this.state.viewMore && plus && (
            <NanoFlex className="moreFilters" onClick={this.toggleViewMore}>
              <Type.p>+{plus}</Type.p>
            </NanoFlex>
          )}
          {/* END  HIGHLIGHT CONTAINER */}
        </NanoFlex>
      </NanoFlex>
    );
  }
}

export class FilterRecapContainer extends BaseComponent {
  constructor(props) {
    super(props);

    this.scrollerRef = React.createRef();
    this.isDown = false;
    this.startX = null;
    this.scrollLeft = null;
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  onMouseDown = (e) => {
    this.isDown = true;
    this.startX = e.pageX - this.scrollerRef.current.offsetLeft;
    this.scrollLeft = this.scrollerRef.current.scrollLeft;
  };

  onMouseLeave = (e) => {
    this.isDown = false;
  };

  onMouseUp = () => {
    this.isDown = false;
  };

  onMouseMove = (e) => {
    if (!this.isDown) return;
    e.preventDefault();
    const x = e.pageX - this.scrollerRef.current.offsetLeft;
    const walk = (x - this.startX) * 3; //scroll-fast
    this.scrollerRef.current.scrollLeft = this.scrollLeft - walk;
  };

  onRecapFiltersClick = () => {
    if (this.props.onRecapFiltersClick) this.props.onRecapFiltersClick();
  };

  onToggleSavedSearch = () => {
    window.dispatchEvent(new Event("toggleAdvancedSearch"));
  };

  openRecapFiltersModal = () => {
    if (this.props.openRecapFiltersModal) this.props.openRecapFiltersModal();
  };

  onClearClick = () => {
    window.dispatchEvent(new CustomEvent("clearSearch", { detail: { searchFrom: "AdvancedSearch" } }));
  };

  render() {
    return (
      <NanoFlex className="recapFiltersContainer">
        <NanoFlex className="iconAside" flexDirection="column" onClick={this.onToggleSavedSearch}>
          <NanoFlex className="iconsWrapper">
            <AdvancedSearchIcon />
          </NanoFlex>
          {!this.props.advancedSearchVisible && (
            <NanoFlex className="btnText">
              <Plus />
              <Type.h6>
                <strong>{this.translation.components.navSearchList.addFilters}</strong>
              </Type.h6>
            </NanoFlex>
          )}
          {this.props.advancedSearchVisible && (
            <NanoFlex className="btnText">
              <Type.h6>
                <strong>{this.translation.components.navSearchList.closeFilters}</strong>
              </Type.h6>
            </NanoFlex>
          )}
        </NanoFlex>
        <NanoFlex ref={this.scrollerRef} onMouseDown={this.onMouseDown} onMouseLeave={this.onMouseLeave} onMouseUp={this.onMouseUp} onMouseMove={this.onMouseMove} className="sliderAside" justifyContent="space-between">
          {/* LIST RECAP FILTERS */}
          <NanoFlex className="sliderListContainer" justifyContent="flex-start">
            {/* ITEM RECAP FILTERS */}
            {this.props.recapFilters.map((item) => {
              return <FilterRecapItem key={item.field} item={item} />;
            })}
            {/* END ITEM RECAP FILTERS */}
          </NanoFlex>

          {/* END RECAP FILTERS */}
        </NanoFlex>
        <NanoFlex className="optionsRecap">
          <NanoFlex className="optionsWrapper" flexDirection="column">
            <NanoFlex className="btnOption" title={this.translation.advancedSearch.reduce} onClick={this.onRecapFiltersClick}>
              <Minus />
            </NanoFlex>
            <NanoFlex className="btnOption" title={this.translation.advancedSearch.clearAll} onClick={this.onClearClick}>
              <Delete />
            </NanoFlex>
          </NanoFlex>
          <NanoFlex className="openModal" title={this.translation.advancedSearch.viewAll} onClick={this.openRecapFiltersModal}>
            <Expand />
          </NanoFlex>
        </NanoFlex>
      </NanoFlex>
    );
  }
}

const StyledNavSearchList = styled.div`
  width: 100%;
  max-width: 100%;
  position: sticky;
  top: ${multiple * 6 + "px"};
  background: ${nota.color.neutral.white};
  z-index: 1;
  margin-top: -${multiple * 2 + "px"};
  min-height: ${multiple * 4 + "px"};
  padding: ${multiple * 2 + "px"} 0;
  z-index: 2;

  .navListContainer {
    width: inherit;
    max-width: inherit;
    padding: 0 ${multiple / 2 + "px"};
    min-height: 40px;
    position: relative;
    .leftAside {
      width: auto;
      .leftInfo {
        width: auto;
      }
    }
    .rightAside {
      width: auto;
      .navItemsContainer {
        width: auto;
        height: auto;
      }
      .selectedInfo {
        width: auto;
        margin-right: ${multiple + "px"};
        p {
          color: ${(props) => (props.selectedDisabled ? nota.color.neutral.NeuThree : nota.color.main.default)};
        }
      }
      .iconsContainer {
        width: auto;
      }
      .iconButtonWrapper {
        cursor: pointer;
        /* width: 20px; */
        width: auto;
        margin-left: ${multiple + "px"};
        .playlistIcon {
          height: 16px;
        }
        svg {
          height: 20px;
          width: auto;
          path,
          rect {
            fill: ${nota.color.neutral.NeuOne};
          }
        }
        &:hover {
          opacity: 0.7;
        }
      }
      .menuExports {
        &:hover {
          opacity: 1;
        }
      }
      .disabled {
        pointer-events: none;
        svg {
          height: 20px;
          width: auto;
          path,
          rect {
            fill: ${nota.color.neutral.NeuThree};
          }
        }
      }
      .selected {
        cursor: pointer;
        svg {
          height: 20px;
          width: auto;
          path,
          rect {
            fill: ${nota.color.main.default};
          }
        }
      }
      .viewListOptions {
        /* margin-left: ${multiple * 2 + "px"}; */
        width: fit-content;
      }
    }
  }

  .selectThumbContainer {
    width: auto;
    margin-right: ${multiple + "px"};
    .selectThumb {
      padding: ${multiple / 2 + "px"};
      background: ${nota.color.neutral.NeuFour};
      width: 18px;
      height: 18px;
      border-radius: 100%;
      cursor: pointer;
      svg {
        path {
          fill: ${nota.color.neutral.NeuTwo};
        }
      }
    }
    .selectedThumb {
      background-color: ${nota.color.main.default};
      svg {
        path {
          fill: ${nota.color.neutral.white};
        }
      }
    }
  }
  /* RECAP FILTERS */
  .recapCollapsed {
    width: auto;
    cursor: pointer;
    margin-left: ${multiple * 2 + "px"};
    background: ${nota.color.neutral.NeuFour};
    width: 28px;
    height: 28px;
    border-radius: 60px;
    svg {
      width: auto;
      height: 14px;
      path {
        fill: ${nota.color.neutral.NeuOne};
      }
      .gear {
        fill: ${nota.color.main.mOne};
      }
    }
  }

  .recapFiltersContainer {
    background: ${nota.color.neutral.NeuFour};
    height: 52px;
    margin-top: ${multiple + "px"};
    border-radius: 60px 0 0 60px;

    min-width: 0;
    .iconAside {
      width: auto;
      margin-right: 8px;
      padding: 0 16px;
      cursor: pointer;
      background-color: ${nota.color.neutral.NeuFive};
      border-radius: 60px 0 0 60px;
      user-select: none;
      svg {
        width: auto;
        height: 20px;
        path {
          fill: ${nota.color.neutral.NeuOne};
        }
        .gear {
          fill: ${nota.color.main.mOne};
        }
      }
      .iconsWrapper {
        height: auto;
      }
      .btnText {
        height: auto;
        width: max-content;
        margin-top: 4px;
        svg {
          width: auto;
          height: 8px;
          margin-right: 4px;
        }
        h6 {
          text-transform: uppercase;
        }
      }
    }
    .sliderAside {
      overflow-y: hidden;
      overflow-x: hidden;
      height: auto;
      min-width: 0;
      .sliderListContainer {
        width: auto;
        cursor: grab;
        cursor: -webkit-grab;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: horizontal;

        .sliderItem {
          width: auto;
          width: max-content;
          /* margin-right: ${multiple / 2 + "px"}; */
          background: ${nota.color.neutral.NeuFour};
          padding: 0px 8px 0 4px;
          user-select: none;
          border-right: 1px solid ${nota.color.neutral.NeuThree};
          margin-left: 8px;
          .titleWrapper {
            height: auto;
            width: auto;
            p {
              font-weight: bold;
              color: ${nota.color.main.mOne};
            }
            .deleteInfo {
              width: auto;
              margin-left: 4px;
              margin-top: 2px;
              background: ${nota.color.neutral.white};
              padding: 2px 4px;
              border-radius: 20px;
              cursor: pointer;
              svg {
                width: auto;
                height: 8px;
                path {
                  fill: ${nota.color.neutral.NeuTwo};
                }
              }
              &:hover {
                svg {
                  path {
                    fill: ${nota.color.main.mTwo};
                  }
                }
              }
            }
          }
          .highlightsList {
            height: auto;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: horizontal;
            .highlightContainer {
              position: relative;
              width: auto;
              .highlightWrapper {
                padding: 4px 8px 4px 0;
                .highlightInfo {
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  max-width: 25ch;
                }
                .nivel2 {
                  margin-left: ${multiple / 2 + "px"};
                  font-size: 12px;
                }
              }

              &:before {
                content: "|";
                display: inline-block;
                color: ${nota.color.neutral.NeuTwo};
                font-size: 14px;
                margin-right: 8px;
              }
              &:first-child {
                &:before {
                  display: none;
                }
              }
            }
          }
          .moreFilters {
            width: auto;
            height: auto;
            background: ${nota.color.neutral.white};
            padding: 2px 4px;
            border-radius: 20px;
            p {
              color: ${nota.color.neutral.NeuOne};
              font-weight: normal;
              font-size: 12px;
            }
          }
          &:last-child {
            margin-right: 0;
            border-right: none;
          }
          &:first-child {
            margin-left: 0;
          }
        }

        &:active {
          cursor: grabbing;
          cursor: -webkit-grabbing;
        }
      }
    }
    .optionsRecap {
      width: auto;
      margin-left: ${multiple + "px"};
      /* background-color: ${nota.color.neutral.NeuFive}; */
      .optionsWrapper {
        padding: ${multiple / 2 + "px"};
        .btnOption {
          cursor: pointer;
          background-color: ${nota.color.neutral.NeuFive};
          padding: 0 8px;
          margin-bottom: ${multiple / 2 + "px"};
          svg {
            width: 8px;
            height: auto;
            path {
              fill: ${nota.color.neutral.NeuOne};
            }
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
      }

      .openModal {
        background-color: ${nota.color.neutral.NeuFive};
        width: auto;
        padding: ${multiple + "px"};
        cursor: pointer;
        svg {
          width: 16px;
          height: auto;
          path {
            fill: ${nota.color.neutral.NeuOne};
          }
        }
      }
    }
  }
  .optionsWrapper {
    width: auto;
    /* margin-right: 8px; */
    .toggleBtnContainer {
      cursor: pointer;
      background-color: ${nota.color.neutral.lightGrey};
      border-radius: 50px;
      padding: 11px ${multiple * 2 + "px"};
      user-select: none;
      width: 160px;
      .iconBtnWrapper {
        width: auto;
        svg {
          width: 23px;
          height: auto;
          path {
            fill: ${nota.color.main.default};
          }
        }
      }
      .textBtnWrapper {
        margin-left: ${multiple + "px"};
      }

      &:hover {
        opacity: 0.7;
      }
    }
  }

  .menuExports {
    opacity: 1;
    .dropdown {
      position: relative;
      top: 0;
      left: 0;
    }
    .dropdown-content {
      left: unset;
      right: -11px;
      margin: 16px 0;
      transform: unset;
    }
  }

  .tooltipWrapper {
    width: 130px;
    border: 1px solid ${nota.color.neutral.NeuTwo};
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    padding: ${multiple + "px"};
    position: relative;
    cursor: default;
    user-select: none;
    &:after,
    &:before {
      bottom: 100%;
      right: 5px;
      border: solid transparent;
      content: " ";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
    }

    &:after {
      border-color: rgba(255, 255, 255, 0);
      border-bottom-color: ${nota.color.neutral.white};
      border-width: 8px;
      margin-right: 0px;
    }
    &:before {
      border-color: rgba(0, 168, 225, 0);
      border-bottom-color: ${nota.color.neutral.NeuTwo};
      border-width: 9px;
      margin-right: -1px;
    }
    .optionLine {
      padding: ${multiple + "px"};
      border-bottom: 0.5px solid ${nota.color.neutral.NeuFour};
      cursor: pointer;
      p {
        letter-spacing: 1px;
        font-size: 12px;
      }

      &:last-child {
        border-bottom: 0;
      }
      &:hover {
        background-color: ${nota.color.neutral.NeuFour};
      }
    }
  }

  .mobileShow {
    display: none;
  }
  /* MEDIA QUERIES */

  @media only screen and (max-width: ${nota.global.breakpoints.tablet + "px"}) {
    .viewListOptions {
      display: none;
    }
  }

  @media only screen and (max-width: 800px) {
    .navListContainer {
      .rightAside {
        .iconButtonWrapper {
          margin-left: ${multiple * 2 + "px"};
        }
      }
    }
  }

  @media only screen and (max-width: 645px) {
    .navListContainer {
      flex-direction: column;
      .leftAside {
        width: 100%;
        justify-content: flex-end;
      }
      .rightAside {
        width: 100%;
        margin-top: 8px;
        .optionsWrapper {
          margin-left: 8px;
          .toggleBtnContainer {
            width: auto;
            padding: 9px 6px;
            .iconBtnWrapper {
              svg {
                width: 16px;
              }
            }
            .textBtnWrapper {
              display: none;
            }
          }
        }
      }
    }
  }

  @media only screen and (max-width: 500px) {
    .navListContainer {
      .leftAside {
        p {
          font-size: 12px;
        }
        .mobileHidden {
          display: none;
        }
      }
      .rightAside {
        .selectedInfo {
          margin-right: 0;
          p {
            font-size: 12px;
            margin-bottom: ${multiple / 2 + "px"};
          }
        }
        .iconsContainer {
          .mobileShow {
            display: flex;
          }
        }
      }
    }

    .recapFiltersContainer {
      .iconAside {
        padding: 0 16px;
      }
      .sliderAside {
        overflow: auto;
        ::-webkit-scrollbar {
          display: none;
        }
      }
    }
  }

  @media only screen and (max-width: 320px) {
    .navListContainer {
      .rightAside {
        flex-direction: column;
        align-items: flex-end;
        .navItemsContainer {
          margin-bottom: 8px;
        }
      }
    }
  }
`;

class NavSearchList extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  openPlaylistModal = () => {
    if (this.props.onOpenPlaylistModal) {
      this.props.onOpenPlaylistModal();
    }
  };

  openRemovePlaylistModal = () => {
    if (this.props.onOpenRemovePlaylistModal) {
      this.props.onOpenRemovePlaylistModal();
    }
  };

  onPdfClick = () => {
    if (this.props.onPdfClick) {
      this.props.onPdfClick();
    }
  };

  onExcelClick = () => {
    if (this.props.onExcelClick) {
      this.props.onExcelClick();
    }
  };

  onIsAllSelectedClick = () => {
    if (this.props.onIsAllSelectedChange) {
      this.props.onIsAllSelectedChange(!this.props.isAllSelected);
    }
  };

  onRecapFiltersClick = () => {
    if (this.props.onRecapFiltersClick) {
      this.props.onRecapFiltersClick();
    }
  };

  openRecapFiltersModal = () => {
    if (this.props.openRecapFiltersModal) {
      this.props.openRecapFiltersModal();
    }
  };

  render() {
    let selectedDisable = this.props.selectedCount === 0;
    let showRecapFilters = this.props.recapFiltersVisible && this.props.openRecapFilters;
    return (
      <StyledNavSearchList selectedDisabled={selectedDisable}>
        {this.props.count > 0 && (
          <NanoFlex className="navListContainer" justifyContent="space-between">
            <NanoFlex className="leftAside" justifyContent="flex-start" alignContent="flex-start">
              <NanoFlex className="leftInfo">
                <Type.p>
                  {this.props.count ? this.props.count : 0} {this.props.count > 1 ? this.translation.geral.programmes : this.translation.geral.programme}
                </Type.p>
              </NanoFlex>
              {this.props.recapFiltersVisible && !this.props.openRecapFilters && (
                <NanoFlex className="recapCollapsed mobileHidden" title={this.translation.components.navSearchList.expandRecapFilters} onClick={this.onRecapFiltersClick}>
                  <AdvancedSearchIcon />
                </NanoFlex>
              )}
            </NanoFlex>

            {this.props.count > 0 && (
              <NanoFlex className="rightAside" justifyContent="flex-end" alignContent="flex-end">
                <NanoFlex className="navItemsContainer">
                  {!this.props.hideSelection && this.props.selectedMenu === "thumbs" && (
                    <NanoFlex className="selectThumbContainer">
                      <NanoFlex className={`selectThumb ${this.props.isAllSelected ? "selectedThumb" : ""}`} onClick={this.onIsAllSelectedClick}>
                        <Check />
                      </NanoFlex>
                    </NanoFlex>
                  )}

                  <NanoFlex className="selectedInfo">
                    <Type.p>
                      <b>{this.props.selectedCount}</b> {this.translation.components.navSearchList.selected}
                    </Type.p>
                  </NanoFlex>

                  {this.props.selectedMenu === "thumbs" && (
                    <NanoFlex className="optionsWrapper">
                      <NanoFlex className="toggleBtnContainer" onClick={this.props.onToggleHideSelection}>
                        <NanoFlex className="iconBtnWrapper">
                          {this.props.hideSelection && <EyeClosed />}
                          {!this.props.hideSelection && <Eye />}
                        </NanoFlex>
                        <NanoFlex className="textBtnWrapper">
                          {this.props.hideSelection && <Type.p>{this.translation.components.navSearchList.showSelected}</Type.p>}
                          {!this.props.hideSelection && <Type.p>{this.translation.components.navSearchList.hideSelected}</Type.p>}
                        </NanoFlex>
                      </NanoFlex>
                    </NanoFlex>
                  )}
                </NanoFlex>

                <NanoFlex className="iconsContainer">
                  {!this._isMobile && this.props.recapFiltersVisible && !this.props.openRecapFilters && (
                    <NanoFlex className="recapCollapsed mobileShow" title={this.translation.components.navSearchList.expandRecapFilters} onClick={this.onRecapFiltersClick}>
                      <AdvancedSearchIcon />
                    </NanoFlex>
                  )}
                  {this._isMobile && (
                    <NanoFlex className="recapCollapsed mobileShow" title={this.translation.components.navSearchList.expandRecapFilters} onClick={this.openRecapFiltersModal}>
                      <AdvancedSearchIcon />
                    </NanoFlex>
                  )}
                  <NanoFlex className={`iconButtonWrapper ${selectedDisable ? "disabled" : ""}`}>
                    <Playlist className="playlistIcon" onClick={this.openPlaylistModal} title={this.translation.components.navSearchList.addToPlaylist} />
                  </NanoFlex>
                  <NanoFlex className={`iconButtonWrapper ${selectedDisable ? "disabled" : ""}`}>
                    <RemovePlaylist onClick={this.openRemovePlaylistModal} title={this.translation.components.navSearchList.removeFromPlaylist} />
                  </NanoFlex>
                  <NanoFlex className={`iconButtonWrapper ${selectedDisable ? "disabled" : ""}`}>
                    <Pdf onClick={this.onPdfClick} title={this.translation.components.navSearchList.exportPdf} />
                  </NanoFlex>
                  <NanoFlex className={`iconButtonWrapper ${selectedDisable ? "disabled" : ""}`}>
                    <Excel onClick={this.onExcelClick} title={this.translation.components.navSearchList.exportExcel} />
                  </NanoFlex>
                  <NanoFlex className="viewListOptions">
                    <NanoFlex className={`iconButtonWrapper ${this.props.selectedMenu === "thumbs" ? "selected" : ""}`}>
                      <Thumbs
                        title={this.translation.components.navSearchList.thumbView}
                        onClick={() => {
                          this.props.onMenuChange("thumbs");
                        }}
                      />
                    </NanoFlex>
                    <NanoFlex className={`iconButtonWrapper ${this.props.selectedMenu === "list" ? "selected" : ""}`}>
                      <List
                        title={this.translation.components.navSearchList.listView}
                        onClick={() => {
                          this.props.onMenuChange("list");
                        }}
                      />
                    </NanoFlex>
                  </NanoFlex>
                </NanoFlex>
              </NanoFlex>
            )}
          </NanoFlex>
        )}
        {!this._isMobile && showRecapFilters && <FilterRecapContainer recapFilters={this.props.recapFilters} onRecapFiltersClick={this.onRecapFiltersClick} openRecapFiltersModal={this.openRecapFiltersModal} advancedSearchVisible={this.props.advancedSearchVisible} />}
        {!this._isMobile && !showRecapFilters && (
          <StyledLoading className="loadingContainer">
            <Spinner />
          </StyledLoading>
        )}
      </StyledNavSearchList>
    );
  }
}

export default NavSearchList;

// --- // Documentation // --- //
/*
import NavSearchList from './../Micro/NavSearchList.js';

<NavSearchList />
*/
